import React from "react"
import { DataTable as TableTitles } from "shared/ui/dataTable"
import { TransactionRow } from "./TransactionRows"
import { PaginationBlock } from "shared/ui/pagination"

const titles = ["ID", "Дата", "Клиент", "Описание", "Сумма"]

export function TransactionTable({ 
  transactions, 
  setRowsPerPage, 
  setCurrentPage, 
  currentPage, 
  rowsPerPage,
  totalPages,
  totalItems 
}) {
  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[1280px]">
        <TableTitles 
          className="grid whitespace-nowrap border-b border-[#EDEDED] sm:tableRows text-[#999999] font-medium pb-2"
          style={{ gridTemplateColumns: '80px 1fr 1fr 2fr 100px 1fr' }}
          titles={titles} 
          type="transaction"
        />
        {transactions.map((transaction, idx) => (
          <div key={idx} className="grid tableRows" style={{ gridTemplateColumns: '80px 1fr 1fr 2fr 100px 1fr' }}>
            <TransactionRow transaction={transaction} />
            <span className="tableRowLine w-full"></span>
          </div>
        ))}
      </div>
      {totalItems > 0 && (
        <div className="mb-4 sm:mt-6 flex sm:justify-end justify-center">
          <PaginationBlock
            pagesCount={totalPages}
            setRowsPerPage={setRowsPerPage}
            currentPage={currentPage}
            setPage={setCurrentPage}
            perPage={rowsPerPage}
            totalItems={totalItems}
          />
        </div>
      )}
    </div>
  )
}
